<template>
	<TnCardVertical
		border
		arrow
		icon
		iconSize="s"
		:card="card"
		:to="link"
	>
		<template
			#graphic
			v-if="image"
		>
			<ImageResponsive v-bind="image" />
		</template>

		<template #default>
			<TnParagraph
				size="s"
				bold
			>
				{{ card?.title }}
			</TnParagraph>
			<div v-html="card?.text" />
		</template>
	</TnCardVertical>
</template>

<script>
import ResponsiveImageViewModel from "~/helpers/ViewModels/ResponsiveImageViewModel.js";

export default defineNuxtComponent({
	name: "AboutSwapCard",

	props: {
		card: {
			type: Object,
			required: true,
		},
	},

	computed: {
		image() {
			return this.card?.image && ResponsiveImageViewModel(this.card?.image);
		},
		link() {
			return this.card?.link?.internalUrl;
		},
	},
});
</script>

<style lang="scss" scoped>
:deep(.top .graphic) {
	overflow: visible;
}
</style>
